import { SupportedLanguages } from "../../../models/constants/supportedLanguages";
import { RootState } from "../../../store/store";

export const selectUserProfile = (state: RootState) => state.userProfile.data;
export const selectUserLoading = (state: RootState) =>
  state.userProfile.loading;
export const selectUserError = (state: RootState) => state.userProfile.error;

export const selectInboxUnreadCount = (state: RootState) =>
  state.userProfile.data?.inboxUnreadCount || 0;

export const selectUserAvatar = (state: RootState) =>
  state.userProfile.data?.profilePictureUrl || "";

export const selectUserLanguage = (state: RootState) =>
  state.userProfile.data?.languageCode || SupportedLanguages.English;
